import en from "./en";
import fr from "./fr";
import type { Resource } from "i18next";
import type { UseTranslationResponse } from "react-i18next";
// eslint-disable-next-line no-restricted-imports
import { useTranslation } from "react-i18next";
import { Translations } from "@shared/i18n/TranslationsEnum";
import { Language } from "@bimone/bimtrack-core";

export const DefaultLanguage = Language.EN;

export const commonTranslations: Resource = {
  en,
  fr
};

export const useCommonTranslations = (): UseTranslationResponse<Translations.Common, unknown> => useTranslation(Translations.Common);